import * as $ from "jquery";

function SupportCategoryGrid() {
	let $gridContainer = $('.js-support-category-grid');


	let trackSupportCategory = function(supportCategory){
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'category' : supportCategory,
			'event' : 'support_category_clicked'
		});
		console.log(window.dataLayer);
	};
	//there may be more than one SupportCategoryGrid Module on a page since its in the nav,
	// so loop through each and setup.
	$gridContainer.each(function(index){
		$(this).addClass('js-support-category-grid-'+index);
		let $gridContainerInstance = $('.js-support-category-grid-'+index);
		let $gridLinks = $gridContainerInstance.find('.js-support-grid-link');
		let $lists = $gridContainerInstance.find('.js-support-category-list');
		let $topLevel = $gridContainerInstance.find('> .js-support-category-list');
		let $otherLevels = $topLevel.find('ul');

		$topLevel.attr('id', 'top-tier' + index);


		//create an icon for each item with a submenu and title it so users know what its for
		$gridLinks.each(function(){
			let $gridLink = $(this);
			if($gridLink.siblings('ul').length) {
				$gridLink.siblings('ul').attr('id', convertToSlug($gridLink.text()) + index );
				$gridLink.addClass('state-has-children');
				$gridLink.attr('href', "#"+convertToSlug($gridLink.text()) + index );
				$gridLink.attr('title', "Has Sub-menu");
				$gridLink.siblings('ul').attr('data-parent', "#"+$gridLink.closest('.js-support-category-list').attr('id') );
			}
		});

		$otherLevels.each(function(){
			let $this = $(this);
			$this.appendTo($gridContainerInstance);
		});

		$lists.removeClass('state-visible');
		$topLevel.addClass('state-visible');

		//set the default height of the initial menu
		$gridContainerInstance.css('height', $(this).outerHeight() + 10);



		//setup click events on the link
		$gridLinks.on('click', function(e) {
			let $this = $(this);
			let clickTarget = $this.attr('href');
			let categoryText = $this. find('.support-category-grid__text').text();
			trackSupportCategory(categoryText);

			//if our link has a hash character indicating a submenu do t
			// otherwise use default click behavior
			if(clickTarget.indexOf("#") !== -1) {
				//if its not the top level element and doesnt have the back button then add it in.
				if(clickTarget != ("#top-tier-" + index)) {
					$gridContainerInstance.find('.js-back-button').addClass('state-visible').attr('href', $(clickTarget).data('parent'));
				}
				//if the back button already exists then just change the url for the back button
				else if (clickTarget != ("#top-tier" + index) && $gridContainerInstance.find('.js-back-button').length) {
					$gridContainerInstance.find('.js-back-button').addClass('state-visible').attr('href', $gridContainerInstance.find(clickTarget).data('parent'));
				}

				//if the target is the top level then remove are back button
				if(clickTarget == "#top-tier" + index) {
					$gridContainerInstance.find('.js-back-button').removeClass('state-visible');
				}

				//remove old state visible elements
				$lists.removeClass('state-visible');

				//add to the target element list so it animates in
				$gridContainerInstance.find(clickTarget).addClass('state-visible');

				//set the height of the container to the new menu
				setVisibleHeight($gridContainerInstance);

				e.preventDefault();
				e.stopPropagation();
			}
			//prevent this from bubbling up to the nav code



		});


		//setup the back button functionality
		$gridContainerInstance.on('click', '.js-back-button', function(e){
			let $targetParent = $(e.target).closest('.js-support-category-grid');
			let $lists = $targetParent.find('.js-support-category-list');
			$lists.removeClass('state-visible');
			let backTarget = $(e.target).attr('href');
			if(backTarget === "#top-tier" + index) {
				$targetParent.find('.js-back-button').removeClass('state-visible');
				$targetParent.find(backTarget).addClass('state-visible');
			} else {
				$targetParent.find(backTarget).addClass('state-visible');
				$targetParent.find('.js-back-button').attr('href', $targetParent.find(backTarget).attr('data-parent'));
			}

			setVisibleHeight($targetParent);
			e.preventDefault();
			e.stopPropagation();
		});
	});


	//function checks to see if there is a back button and sets the container height accordingly
	function setVisibleHeight(instance){
		let $visibleList = instance.find('.js-support-category-list.state-visible');
		instance.css('height', instance.find('.js-back-button').length ? $visibleList.outerHeight() + instance.find('.js-back-button').outerHeight() : $visibleList.outerHeight());
	}

	$(window).on('resize', function() {
		setVisibleHeight($gridContainer);
	});
}

function convertToSlug(Text)
{
	return Text
		.toLowerCase()
		.replace(/[^\w ]+/g,'')
		.replace(/ +/g,'-');
}


export function init() {
	SupportCategoryGrid();
}



// WEBPACK FOOTER //
// ./js/PFF/modules/supportCategoryGrid.ts